export enum ConditionalOperator {
  LessThan = 'lt',
  Equal = 'eq',
  GreaterThan = 'gt',
}
